import React from 'react';
import {
  Content,
  Container,
  EventInformation,
  Minute,
  DataContainer,
  Text,
} from 'app/components/matchEvents/MatchEventStyles';
import {COLORS, Line} from '@fupa/fupa-uikit';
import {ErrorOutline, InfoOutlined} from '@mui/icons-material';
import {Whistle} from 'app/components/icons';

const MatchEventSingleText = ({event, icon, iconColor}) => {
  let displayedIcon;
  const iconStyle = {color: iconColor ?? COLORS.darkGrey, fontSize: 16};
  switch (icon) {
    case 'whistle':
      displayedIcon = <Whistle style={iconStyle} />;
      break;
    case 'teamFoul':
      displayedIcon = <ErrorOutline style={iconStyle} />;
      break;
    default:
      displayedIcon = <InfoOutlined style={iconStyle} />;
  }
  const time = event.additionalMinute > 0 ? `${event.minute}'+${event.additionalMinute}` : `${event.minute}'`;

  return (
    <Content>
      <Container>
        <EventInformation>
          <Minute variant='subheading2' component='span'>
            {time}
          </Minute>
          {displayedIcon}
        </EventInformation>
        <DataContainer>
          <Text variant='body2'>{event.text}</Text>
        </DataContainer>
      </Container>
      <Line />
    </Content>
  );
};

export default MatchEventSingleText;
